import React from 'react';
import {PricingTableContainer} from "./styled";
import {PricingCard} from "./PricingCard/PricingCard";

export const PricingTable = ({plans = []}) => {
    if (!plans || plans.length === 0) {
        return null;
    }

    return (
        <PricingTableContainer>
            {plans.map((plan, index) => {
                const planData = plan?.item || plan || {};
                return <PricingCard key={planData.id || index} plan={planData} />;
            })}
        </PricingTableContainer>
    );
}
